import React, { useEffect, useState } from 'react';

import { ExpandCollapse, Typography } from '@telus-uds/components-web';
import moment from 'moment-timezone';

import PropTypes from 'prop-types';

import request from '../../utils/request';
import {
  OrderHistoryMain,
  OrderHistoryDataMain,
  OrderHistoryTimestamp,
  OrderHistoryAction
} from '../css';

const OrderHistory = ({ orderId }) => {
  const [orderHistory, setOrderHistory] = useState();

  useEffect(() => {
    request.get(`/orders/${orderId}/order-history`).then(result => {
      setOrderHistory(result.data);
    });
  }, []);

  const getLocalFormattedTime = (date, time) => {
    const localZone = moment.tz.guess();
    const format = 'hh:mm A';
    const dateTime = `${date} ${time}`;

    return `${moment
      .utc(dateTime)
      .local()
      .format(format)} ${moment.tz.zone(localZone).abbr(360)}`;
  };

  return (
    <OrderHistoryMain>
      {orderHistory &&
        Object.keys(orderHistory).map(date => {
          return (
            <ExpandCollapse key={date} initialOpen={[]} tag="h2" topDivider={false}>
              {(expandProps) => (
                <ExpandCollapse.Panel
                  {...expandProps}
                  panelId={date}
                  control={<Typography variant={{ bold: true }}>{date}</Typography>}
                >
                  {orderHistory[date].map(data => (
                    <OrderHistoryDataMain key={`${date}-${data.timeStamp}`}>
                      <OrderHistoryTimestamp>
                        {getLocalFormattedTime(date, data.timeStamp)}
                      </OrderHistoryTimestamp>
                      <OrderHistoryAction>{`${data.action} by ${data.user}`}</OrderHistoryAction>
                    </OrderHistoryDataMain>
                  ))}
                </ExpandCollapse.Panel>
              )}
            </ExpandCollapse>
          );
        })}
    </OrderHistoryMain>
  );
};

OrderHistory.propTypes = {
  orderId: PropTypes.number.isRequired
};

export default OrderHistory;
